module.exports = __webpack_public_path__ + "img/light-l.022cee20.png";